import { useState } from 'react'
import { Close } from '@mui/icons-material'
import { CardContent, Divider, Tab, Tabs } from '@mui/material'
import {
  Box,
  Card,
  CardHeader,
  Chip,
  IconButton,
  Modal,
  TabPanel
} from 'components'
import { useLoadCustomerInfo } from './useLoadCustomerInfo'
import { useFormContext } from 'react-hook-form'
import { Credit } from './financial'
import { OverDues } from './overDues'
import { Observations } from './observations'
import { HiPlus } from 'react-icons/hi'
import { useLoadOrderClientOverduePayments } from 'modules/orders/hooks'

const InfoModal = ({ open, onClose, customer }: any) => {
  const [value, setValue] = useState(0)
  const customerName = customer?.name
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}
    >
      <Card style={{ padding: 0, minWidth: 300, width: 600 }}>
        <CardHeader
          title={`${customerName}`}
          HeaderRight={
            <IconButton onClick={() => onClose()}>
              <Close />
            </IconButton>
          }
        />
        <Divider />

        <CardContent style={{ padding: 0, height: 400 }}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              width: '100%'
            }}
          >
            <Tabs value={value} onChange={handleChange} variant="fullWidth">
              <Tab label="Crédito" />
              <Tab label="Títulos Vencidos" />
              <Tab label="Observações" />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Credit />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <OverDues />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Observations />
          </TabPanel>
        </CardContent>
      </Card>
    </Modal>
  )
}

export function CustomerInfoModal() {
  const [open, setOpen] = useState(false)
  const { watch } = useFormContext()
  const customer = watch('customer')
  const customerId = customer?.id

  const { data: customerInfo, isFetching } = useLoadCustomerInfo({
    customerId
  })

  const { data: orderClientOverdue } = useLoadOrderClientOverduePayments({
    customerId
  })

  const onOpen = () => {
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }

  const isOverdue = (orderClientOverdue?.data?.length || 0) > 0

  return (
    <>
      {(!!customerInfo || isFetching) && (
        <Chip
          label="Mais Informações"
          onClick={onOpen}
          icon={<HiPlus size={14} color={isOverdue ? 'white' : '#616161'} />}
          disabled={isFetching}
          style={{
            paddingLeft: 4,
            paddingRight: 4,
            backgroundColor: isOverdue ? '#ff4d4f' : '#ebebeb',
            color: isOverdue ? 'white' : '#616161'
          }}
        />
      )}

      {open && <InfoModal open={open} onClose={onClose} customer={customer} />}
    </>
  )
}
